import timestring from 'timestring';
import localforage from 'localforage';
export class CacheService {
    constructor(config = {}) {
        this._config = { maxAge: '1 day' };
        this.encode = (value) => ({
            value,
            time: Date.now()
        });
        this.decode = ({ value, time }, maxAge) => {
            if (time + timestring(maxAge || this._config.maxAge || '', 'ms') <
                Date.now()) {
                return null;
            }
            return value;
        };
        this.read = async (key, maxAge) => {
            try {
                const entry = await this._storage.getItem(key);
                return entry ? this.decode(entry, maxAge) : null;
            }
            catch (e) {
                console.error(e);
                return null;
            }
        };
        this.write = async (key, value) => {
            try {
                return (await this._storage.setItem(key, this.encode(value))).value;
            }
            catch (e) {
                console.error(e);
                return null;
            }
        };
        this.delete = (key) => this._storage.removeItem(key);
        this.clearCache = () => this._storage.clear();
        this._config = { ...this._config, ...config };
        this._storage = localforage.createInstance({
            name: 'platform'
        });
    }
}
export default CacheService;
//# sourceMappingURL=cache.service.js.map